import { defaultLeaseApplication } from '../tests/test-objects';
import { Contracts, LeaseApplication } from '../types/instant-lease-api';

export const contracts = () =>
  Promise.resolve<Contracts>({
    contracts: [
      {
        app_uuid: '1',
        creation_date: '',
        document_key: '',
        document_type: '',
        user_id: '',
      },
      {
        app_uuid: '2',
        creation_date: '',
        document_key: '',
        document_type: '',
        user_id: '',
      },
      {
        app_uuid: '3',
        creation_date: '',
        document_key: '',
        document_type: '',
        user_id: '',
      },
    ],
    message: '',
    status: 0,
    timestamp: '',
  });

export const contract = (uuid: string) =>
  Promise.resolve<LeaseApplication>({ ...defaultLeaseApplication, uuid });
